<script>
  import PageWithRelatedTemplate from 'src/views/PageWithRelated';

  export default {
    name: 'VideoPage',
    extends: PageWithRelatedTemplate,
  };
</script>
